export class TpoCertificationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getActive({ subCompanyId }) {
    return this.#http.get('/api/admin-panel/tpo-certifications/active', {
      params: { subCompanyId },
    });
  }

  async getIframeBaseUrl({ subCompanyId }) {
    return this.#http.get('/api/admin-panel/tpo-certifications/iframe-base-url', {
      params: { subCompanyId },
    });
  }

  // DEV-3025: certification history for a sub-company — current + prior cycles.
  // Used as the source for the AI Activity start-drawer certification-subject picker.
  async getHistory({ subCompanyId }) {
    return this.#http.get(
      `/api/admin-panel/sub-companies/${subCompanyId}/tpo-certifications/history`,
    );
  }
}
